export const company = {
  name: 'Acu Legal & Fiduciary Services',
  nameLine1: 'Acu Legal &',
  nameLine2: 'FIDUCIARY SERVICES',
  monogram: 'A',
  logoUrl: 'https://cdn.magicpatterns.com/uploads/rgLLsDWTfrizpx8PSbuJv3/ACU.png',
  phoneDisplay: '+1 (325) 305-8665',
  phoneHref: 'tel:+13253058665',
  email: 'inquiries@aculegalservices.com',
  addressLine1: '1705 Campus Ct',
  addressLine2: 'Abilene, TX 79601',
  hours: 'Monday – Friday, 9:00 AM – 5:00 PM CT',
}
